import { PDFJob, Project } from "@nova/protobuf"
import {
    createdByValidators,
    entityValidator,
    idValidators,
    nameValidators,
    parentIdValidators,
    UnionToTuple,
} from "../util"
import { JobStatusType } from "@nova/constants"
import { dateAsNumber } from "../../util"
import { createNewPDFFractionalIndex } from "../../util/fractional_indexing"
const pdfIndexValidators = [
    {
        validator: (index: string, layer: PDFJob, project: Project) => {
            const layers = project.PDFs

            const siblings = layers.filter(
                (potentialSibling) =>
                    potentialSibling.parentId === layer.parentId && potentialSibling.id !== layer.id
            )

            return !siblings.some((sibling) => sibling.index === index)
        },
        error: "Index is invalid: Index is identical to some sibling's index",
    },
]
export const createPDFJobValidator = entityValidator(PDFJob, {
    name: { validators: nameValidators, nonNull: true },
    id: { validators: idValidators, nonNull: true },
    index: { validators: pdfIndexValidators, nonNull: true },
    parentId: { validators: parentIdValidators },
    createdBy: { validators: createdByValidators, nonNull: true },
})

export const updatePDFJobValidator = entityValidator(PDFJob, {
    index: {
        validators: pdfIndexValidators,
        nonNull: true,
    },
    parentId: { validators: parentIdValidators },
    name: {
        validators: nameValidators,
        nonNull: true,
    },
})

export const getDefaultPDFJobCreateArgs = (project: Project) => ({
    createdAt: dateAsNumber(),
    status: JobStatusType.QUEUED,
    hasPreview: true,
    parentId: undefined,
    index: createNewPDFFractionalIndex(project),
    updatedAt: dateAsNumber(),
    hasEmbeddedNovaContext: true,
    corners: [],
})

export type CreatePDFJobArgs = UnionToTuple<keyof typeof createPDFJobValidator>
export type UpdatePDFJobArgs = UnionToTuple<keyof typeof updatePDFJobValidator>
